import axios from 'axios';

/**
 * 業種マスタ全取得
 */
export const getPartnerCategories = () => {
  return axios
    .get(`/api/v1/partner-category/master`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 業種マスタ並び替え
 */
export const sortPartnerCategoryItems = (order_list: any) => {
  return axios
    .post(
      `/api/v1/partner-category/update/order`,
      {
        order_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 大項目新規作成
 */
export const createPartnerCategoryItems = (name: string) => {
  return axios
    .post(
      `/api/v1/partner-category/create/category`,
      {
        name
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 小項目新規作成
 */
export const createPartnerCategoryDetailItems = (
  name: string,
  partner_category_id: number
) => {
  return axios
    .post(
      `/api/v1/partner-category/create/category/detail`,
      {
        name,
        partner_category_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 大項目更新
 */
export const updatePartnerCategoryItems = (id: number, name: string) => {
  return axios
    .put(
      `/api/v1/partner-category/update/category`,
      {
        id,
        name
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 小項目更新
 */
export const updatePartnerCategoryDetailItems = (
  id: number,
  name: string,
  partner_categories_id: number
) => {
  return axios
    .put(
      `/api/v1/partner-category/update/category/detail`,
      {
        id,
        name,
        partner_categories_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 大項目の削除
 */
export const deleteCategoryItemById = (delete_id: number) => {
  return axios
    .delete(`/api/v1/partner-category/delete/category/${delete_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 小項目の削除
 */
export const deleteCategoryDetailItemById = (delete_id: number) => {
  return axios
    .delete(`/api/v1/partner-category/delete/category/detail/${delete_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
